// Web connectivity signal for the offline outbox: navigator.onLine plus the
// online/offline events. This is only ever a fast *negative* signal — a
// false positive from navigator.onLine (e.g. connected to a captive portal)
// just means a drain attempt fails and the sync engine backs off normally;
// positive connectivity is proven by an upload actually succeeding.

export function isOnline(): boolean {
  if (typeof navigator === 'undefined' || typeof navigator.onLine !== 'boolean') return true;
  return navigator.onLine;
}

export function subscribeOnline(cb: (online: boolean) => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const onOnline = () => cb(true);
  const onOffline = () => cb(false);
  window.addEventListener('online', onOnline);
  window.addEventListener('offline', onOffline);
  return () => {
    window.removeEventListener('online', onOnline);
    window.removeEventListener('offline', onOffline);
  };
}
